module.exports = __webpack_public_path__ + "static/img/naturalCircle3.aa28482.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naturalCircle3.svg
// module id = gmY2
// module chunks = 1